import { Box, Grid, Typography } from '@mui/material';
import { styled } from '@mui/system';
import logo from '../../../assets/images/logo-fitradio.png';
import { theme } from '../../../theme';
import { Logo } from '../questionnaire-wizard.styles';
import { AGREEMENT_CLAUSES, renderClauseParts } from './clauses';

const TitleSecundary = styled(Typography)({
  fontFamily: 'Montserrat',
  fontSize: '1.4rem',
  textTransform: 'uppercase',
  color: theme.palette.primary.main,
  fontWeight: 'bold',
  marginBottom: '15px',
});

const ContainerText = styled(Grid)({
  margin: '20px 0',
});

const CustomLink = styled(Typography)({
  fontFamily: 'Montserrat',
  fontSize: '1rem',
  color: theme.palette.primary.main,
  marginBottom: '15px',
  textDecoration: 'underline',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.primary.main,
  },
});

const TextBody = styled(Typography)({
  fontFamily: 'Montserrat',
  fontSize: '1rem',
  lineHeight: '1.4rem',
  fontWeight: '400',
  color: '#000000',
});

const AgreementPage = () => {
  return (
    <>
      <Logo>
        <img alt="FitRadio" src={logo} />
      </Logo>
      <TitleSecundary variant="h2" textAlign="center">
        MUSIC LICENSING TERMS AND CONDITIONS
      </TitleSecundary>
      <ContainerText>
        <TextBody component="span" variant="body2">
          Thank you. Before you place your order, please review our{' '}
          <CustomLink
            component="a"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.fitradio.com/tos"
          >
            terms and conditions
          </CustomLink>
          , and our{' '}
          <CustomLink
            component="a"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.fitradio.com/privacy"
          >
            privacy policy
          </CustomLink>
          . By placing your order you are agreeing to be bound by our terms and conditions,
          including, but not limited to the following:
        </TextBody>
      </ContainerText>
      <Box component="ol" sx={{ paddingLeft: '20px' }}>
        {AGREEMENT_CLAUSES.map((clause) => (
          <Typography key={clause.id} component="li">
            <ContainerText>
              <TextBody component="span" variant="body2">
                {clause.text
                  ? clause.text
                  : renderClauseParts(clause.parts, (props) => (
                      <CustomLink component="a" {...props} />
                    ))}
              </TextBody>
            </ContainerText>
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default AgreementPage;
